import React, { FC } from "react";
import { List, ListItem } from "react-toolbox/lib/list";

import { AppIcon } from "components/AppIcon";
import { FavoriteApp } from "../utils";

import theme from "styles/overrides/list-compact.scss";
import style from "./style.scss";

export interface FavoritesAppsProps {
    apps: FavoriteApp[];
    compact?: boolean;
    onNavClick(path: string): void;
}

const FavoritesApps: FC<FavoritesAppsProps> = (props: FavoritesAppsProps) => {
    if (props.apps.length === 0) {
        return <div />;
    }

    let apps = props.apps;
    let wrapClassName = style.wrap;
    let listItemTheme: object;

    if (props.compact) {
        wrapClassName = style.compact;
        listItemTheme = theme;
        apps = apps.slice(0, 3);
    }

    function renderTitle() {
        if (!props.compact) {
            return <h2 className={style.title}>Recently Visited Apps</h2>;
        }
    }

    return (
        <div className={wrapClassName}>
            {renderTitle()}

            <List theme={theme}>
                {apps.map((app, i) => {
                    const appLink = `/${app.orgId}/${app.appId}`;
                    const leftIcon = <AppIcon app={app} />;

                    return (
                        <ListItem
                            theme={listItemTheme}
                            key={i}
                            caption={app.name || app.appId}
                            leftIcon={leftIcon}
                            legend={app.orgName}
                            onClick={props.onNavClick.bind(undefined, appLink)}
                            selectable
                        />
                    );
                })}
            </List>
        </div>
    );
};

export { FavoritesApps };
